import { bulkExportUrlv2 } from "../../../../bulkexport/api/bulkBaseUrl";
import { favouritesBaseApiUrl } from "../../favouritesBaseUrl";

export const favouriteitemsUrl = `${favouritesBaseApiUrl}/favourites`;
export const favouriteBulkUrl = `${bulkExportUrlv2}/favorite`;

export const favouriteItemsKey = "favouriteItems";
